import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import AddAssetsPageWidget  from './addAssetsPageWidget'
import { Spinner } from 'evergreen-ui'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Cookies from 'js-cookie';


function AddAssets() {
const history = useHistory()

const managerType = Cookies.get('managerType');
if(managerType ==='sub'){
  history.push(`/dashboard`);
  return <Spinner/>
}

  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m9'>
                {/* <div className='container'> */}
                   <AddAssetsPageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default AddAssets